<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="confirmar" persistent max-width="330">
        <v-card>
          <v-card-title>Eliminar</v-card-title>
          <v-card-text>Esta seguro que desea eliminar el registro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="
                eliminar()
                confirmar = false
              "
              >Aceptar</v-btn
            >
            <v-btn color="red darken-1" text @click="confirmar = false"
              >Cancelar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="darAlta" hide-overlay persistent width="650">
      <v-card>
        <v-system-bar color="headeryfooter darken-2" dark>
          Nueva Patología
          <v-spacer></v-spacer>
          <v-icon @click="cancelarNuevo">mdi-close</v-icon>
        </v-system-bar>
        <v-container>
          <v-row
            justify="center"
            align="center"
            style="border-bottom: 1px gray solid"
          >
            <v-col md="7">
              <v-text-field
                type="text"
                dense
                hide-details
                outlined
                v-model="nuevo.descripcion_patologia"
                placeholder="Patología"
                label="Patología"
              ></v-text-field>
            </v-col>
            <v-col md="3">
              <v-switch
                v-model="nuevo.aplicacoseguro"
                label="Coseguro"
              ></v-switch>
            </v-col>
            <v-col md="2">
              <v-btn v-if="nuevo.descripcion_patologia.trim().length > 0" @click="guardarNuevo" small dark color="teal">
                Aceptar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-col md="5">
        <v-card color="fondoformulario">
          <v-card-title>
            <v-col md="8">
              <v-text-field
                v-model="busqueda"
                prepend-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
                clearable
                clear-icon="mdi-close-circle-outline"
              ></v-text-field>
            </v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn @click="setNuevo" small fab dark v-on="on" color="teal">
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Nueva Patologia</span>
            </v-tooltip>
          </v-card-title>
          <v-card-text>
            <h3 class="text-center">Patologia</h3>
            <v-divider class="mb-2"></v-divider>
            <div style="max-height: 80vh" class="overflow-y-auto">
              <v-row
                v-for="(entidad,index) in ListaFiltrada"
                :key="entidad.id_patologia"
                justify="center"
                align="center"
                style="border-bottom: 1px #cacaca solid;"
                :class="index % 2 === 0 ? 'bg1' : 'bg2'"
                dense
              >
                <v-col md="7">
                  <v-text-field
                    full-width
                    type="text"
                    dense
                    outlined
                    v-model="entidad.descripcion_patologia"
                    @change="guardar(entidad)"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col md="2">
                  <v-switch
                    v-model="entidad.aplicacoseguro"
                    @change="guardar(entidad)"
                    label="Coseguro"
                  ></v-switch>
                </v-col>
                <v-col md="1">
                  <v-btn color="red darken-1" text @click="entidadEliminar = entidad.id_patologia; confirmar = true">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Tabla from '@/components/ABM/Tabla'
import { mapState } from 'vuex'

export default {
  name: 'Patologias',
  components: {
    Tabla
  },
  data() {
    return {
      entidadEliminar: 0,
      busqueda: '',
      confirmar: false,
      nuevo: {
        id_patologia: 0,
        descripcion_patologia: '',
        aplicacoseguro: false
      }
    }
  },
  computed: {
    ...mapState('patologias', ['Lista']),
    ListaFiltrada() {
      let busqueda = this.busqueda || ''
      return this.Lista.filter(
        (x) =>
          x.id_patologia > 0 &&
          x.descripcion_patologia
            .toUpperCase()
            .indexOf(busqueda.toUpperCase()) > -1
      )
    },
    darAlta() {
      if (this.Seleccionado !== undefined) {
        if (this.Seleccionado.id_patologia === 0) {
          return true
        }
      }
      return false
    },
    Seleccionado() {
      return this.$store.state['patologias'].Seleccionado
    }
  },
  methods: {
    guardar(entidad) {
      if (entidad.descripcion_patologia.length > 0) {
        this.$store.dispatch('patologias/guardarEntidad', entidad)
      }
    },
    eliminar() {
      this.$store.dispatch('patologias/eliminar', this.entidadEliminar)
    },
    selectPorId() {
      this.$store.dispatch('patologias/selectPorId')
    },
    setNuevo() {
      this.$store.dispatch('patologias/setNuevo')
    },
    cancelarNuevo() {
      this.selectPorId(-1)
    },
    guardarNuevo() {
      if (this.nuevo.descripcion_patologia.length > 0) {
        this.$store.dispatch('patologias/guardarEntidad', this.nuevo)
        this.nuevo = {
          id_patologia: 0,
          descripcion_patologia: '',
          aplicacoseguro: false
        }
        this.darAlta = false
      } else {
      }
    }
  }
}
</script>
<style>
.bg1 {
  background-color: #d3f4fa;
}
.bg2 {
  background-color: #afd3df;
}
</style>
